import { Link } from "react-router-dom";

/**
 * Zenstrust brand mark (lotus + wordmark).
 * The image already contains the "Zenstrust" word, so no additional text is rendered.
 *
 * Props:
 *   size: tailwind height class — default "h-11" (~44px). Use larger in footer/auth.
 *   to: route to navigate to on click. If null, renders without a link wrapper.
 *   src: image path — defaults to the dark wordmark. Pass the white variant
 *        ("/zenstrust-logo-white.png") when placing it on a dark surface.
 *   className: extra classes for the <img>
 */
export default function Logo({ size = "h-11", to = "/", src = "/zenstrust-logo.png", className = "" }) {
  const img = (
    <img
      src={src}
      alt="Zenstrust"
      data-testid="brand-logo-image"
      className={`${size} w-auto rounded-md select-none object-contain ${className}`}
      draggable={false}
    />
  );
  if (!to) return img;
  return (
    <Link to={to} data-testid="brand-logo" className="inline-flex items-center group" aria-label="Zenstrust home">
      {img}
    </Link>
  );
}
